import { TabContext } from "@mui/lab";
import { Box, Step, StepLabel, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import HarizonAddCandidateIco from "../../assets/icons/HarizonAddCandidateIco";
import HarizonNewJobIco from "../../assets/icons/HarizonNewJobIco";
import HarizonQuickMatchIco from "../../assets/icons/HarizonQuickMatchIco";
import StepperActiveIco from "../../assets/icons/StepperActiveIco";
import StepperDefaultIco from "../../assets/icons/StepperDefaultIco";
import StepperInprogressIco from "../../assets/icons/StepperInprogressIco";
import CommonButton from "../../component/Button";
import SnackBar from "../../component/SnackBar";
import { UploadJob } from "../../redux/action/QuickMatch";
import { ResumeIntelligenceUpload } from "../../redux/action/ResumeIntelligence";
import {
  CommonGrid2,
  TabPanelView,
} from "../common-components/StyledComponents";
import EnrichCandidate from "./components/EnrichCandidate";
import EnrichJob from "./components/EnrichJob";
import GetStarted from "./components/GetStarted";
import Introduction from "./components/Introduction";
import QuickMatch from "./components/QuickMatch";
import StartDemo from "./components/StartDemo";
import { CustomTab, StepperStyle, StepperTabList } from "./style";
import { GetStartedCall } from "../../redux/action/OnBoarding";
import {
  CandidateChatBot,
  CandidateChatBotGetCall,
  ChatBotCall,
  ChatBotGetCall,
  SupportCall,
  SupportGetCall,
} from "../../redux/action/ChatBot";
import CandidateSupportIco from "../../assets/icons/CandidateSupportIco";
import SupportIco from "../../assets/icons/SupportIco";
import useMeasure from "react-use-measure";
import { platformWhiteLogo } from "../../utils/logo";

export default function OnBoarding() {
  const [activeStep, setActiveStep] = useState(0);
  const [value, setValue] = useState("");
  const [quickMatchValue, setQuickMatchValue] = useState(0);
  const [enrichJobValue, setEnrichJobValue] = useState(0);
  const [enrichCandidateValue, setEnrichCandidateValue] = useState(0);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [ref, bounds] = useMeasure();
  const [isDragging, setIsDragging] = useState(false);
  const [files, setFiles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [candidateFiles, setCandidateFiles] = useState([]);
  const [isCandidateDragging, setIsCandidateDragging] = useState(false);
  const [enableSample, setEnableSample] = useState(false);
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: "",
    severity: "error",
  });
  const localStorageData = JSON.parse(localStorage.getItem("credential"));
  const query = new URLSearchParams(useLocation().search);
  const jobId = query.get("id");
  const viewId = query.get("view-id");
  const localData = JSON.parse(localStorage.getItem("credential"));
  const [uploadJobData, setUploadJobData] = useState({});
  const allowedTypes = [
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ];
  const [iconVisible, setIconVisible] = useState(true);
  const enrichButtonSupport = [
    {
      name: "Job",
      icon: <CandidateSupportIco />,
    },
    {
      name: "Support",
      icon: <SupportIco />,
    },
  ];
  const candidateButtonSupport = [
    {
      name: "Candidate",
      icon: <CandidateSupportIco />,
    },
    {
      name: "Support",
      icon: <SupportIco />,
    },
  ];
  const [chatBotData, setChatBotData] = useState({
    message: [],
    // [
    //   // { sender: "bot", text: "Hi, I am Hailey. How can I assist you today?" },
    // ],
    value: "",
    loader: false,
    pageLoader: false,
    arrow: true,
    bubble: [],
    bubbleCondition: false,
    selectedValue: "Job",
  });
  const [isBottomVisible, setIsBottomVisible] = React.useState(true);
  const [list, setList] = useState({
    progress: 0,
    buffer: 0,
  });
  const initialStep = [
    {
      label: "Step 1",
      description: "Who we are ?",
      status: "In Progress",
    },
    {
      label: "Step 2",
      description: "Demo",
      status: "Pending",
    },
    {
      label: "Step 3",
      description: "Get Started",
      status: "Pending",
    },
  ];

  useEffect(() => {
    navigate("/onboarding");
  }, []);

  const [steps, setSteps] = useState(initialStep);
  const quickLinkData = [
    {
      icon: <HarizonNewJobIco />,
      title: "Enrich a Job",
      description: "Enrich a new job using a sample Job Description",
      selected: false,
    },
    {
      icon: <HarizonAddCandidateIco />,
      title: "Enrich  Candidate Profile",
      description: "Enrich a Candidate profile using a sample Resume",
      selected: false,
    },
    {
      icon: <HarizonQuickMatchIco />,
      title: "Quick Match",
      description: "Match sample Job Description to Resumes instantly",
      selected: false,
    },
  ];
  const [filteredQuickLink, setFilteredQuickLink] = useState(quickLinkData);

  const QontoStepIcon = ({ active, completed }) => {
    if (completed) {
      return <StepperActiveIco />;
    }
    if (active) {
      return <StepperInprogressIco />;
    } else return <StepperDefaultIco />;
  };

  const handleNext = (condition) => {
    setValue("");
    setSteps((prevSteps) =>
      prevSteps.map((step, index) => {
        if (index < condition) {
          return { ...step, status: "Completed" };
        } else if (index === condition) {
          return { ...step, status: "In Progress" };
        } else {
          return { ...step, status: "Pending" };
        }
      })
    );

    setActiveStep((prev) => Math.min(prev + 1, steps.length - 1));
  };

  const handleBack = (condition) => {
    if (condition === 0) {
      setFilteredQuickLink((prev) =>
        prev.map((item, index) => {
          return {
            ...item,
            selected: false,
          };
        })
      );
    }
    setSteps((prevSteps) =>
      prevSteps.map((step, index) => {
        if (index === condition) {
          return { ...step, status: "In Progress" };
        } else if (condition > index) {
          return { ...step, status: "Pending" };
        } else {
          return { ...step, status: "Pending" };
        }
      })
    );
    setActiveStep((prev) => Math.max(prev - 1, 0));
  };

  const handleDemoBack = (condition, value) => {
    if (condition === "demo") {
      setValue(value);
    } else if (condition === "back_to_demo") {
      navigate("/onboarding");
      setValue(value);
    } else if (condition === "quick_match") {
      setQuickMatchValue(value);
    } else if (condition === "enrich_job") {
      setEnrichJobValue(value);
    } else if (condition === "enrich_candidate") {
      setEnrichCandidateValue(value);
    }
    setFiles([]);
    setCandidateFiles([]);
    setIsLoading(false);
    setList({ progress: 0, buffer: 0 });
  };

  const handleSkip = () => {
    setActiveStep(2);

    setSteps((prevSteps) =>
      prevSteps.map((step, index) => {
        if (index < 2) {
          return { ...step, status: "Completed" };
        } else if (index === 2) {
          return { ...step, status: "In Progress" };
        } else {
          return { ...step, status: "Pending" };
        }
      })
    );
    // navigate("/home");
  };

  const handleDemoCardChange = (index) => {
    setValue(index);
    if (index === 0) {
      setEnrichJobValue(0);
    } else if (index === 1) {
      setEnrichCandidateValue(0);
    } else if (index === 2) {
      setQuickMatchValue(0);
    }
    // navigate(
    //   // `/onboarding?id=${uploadJobData?.onboarding}&title=${uploadJobData?.resume_info?.inferred_title}`
    //   `/onboarding?id=6b830798-57a2-418a-a40f-540fbc6c49f4&title=Senior Data Science Manager`
    // );
    // setFilteredQuickLink((prev) =>
    //   prev.map((item, index) => {
    //     if (index === 2) {
    //       return {
    //         ...item,
    //         selected: true,
    //       };
    //     }
    //     return item;
    //   })
    // );
  };

  const handleCheckChange = (index) => {
    const updated = [...filteredQuickLink];
    updated[index].selected = !updated[index].selected;
    setFilteredQuickLink(updated);
  };

  const handleClickDemo = (condition) => {
    setEnableSample(false);
    if (condition === "customer_upload") {
      setQuickMatchValue(1);
    } else if (condition === "enrich_job") {
      setEnrichJobValue(1);
    } else if (condition === "enrich_candidate") {
      setEnrichCandidateValue(1);
    }
  };

  const handleClickSample = async (condition) => {
    if (condition === "enrich_job") {
      setEnrichJobValue(1);
      const response = await fetch("/sample_jd.docx");
      const blob = await response.blob();
      const file = new File([blob], "sample_jd.docx", { type: blob.type });
      const enrichedFile = {
        file,
        name: file.name,
        size: `${(file.size / 1024).toFixed(1)} KB`,
        type: file.type,
        progress: 0,
        buffer: 0,
        visible: false,
        delete: true,
        message: "",
      };
      setFiles([enrichedFile]);
    } else if (condition === "enrich_candidate") {
      setEnrichCandidateValue(1);
      const response = await fetch("/sample_resume.docx");
      const blob = await response.blob();
      const file = new File([blob], "sample_resume.docx", { type: blob.type });
      const enrichedFile = {
        file,
        name: file.name,
        size: `${(file.size / 1024).toFixed(1)} KB`,
        type: file.type,
        progress: 0,
        buffer: 0,
        visible: false,
        delete: true,
        message: "",
      };
      setFiles([enrichedFile]);
    } else if (condition === "quick_match") {
      setQuickMatchValue(1);
      setEnableSample(true);
      const response = await fetch("/sample_jd.docx");
      const blob = await response.blob();
      const file = new File([blob], "sample_jd.docx", { type: blob.type });
      const enrichedFile = {
        file,
        name: file.name,
        size: `${(file.size / 1024).toFixed(1)} KB`,
        type: file.type,
        progress: 0,
        buffer: 0,
        visible: false,
        delete: true,
        message: "",
      };
      setFiles([enrichedFile]);
    } else if (condition === "quick_match_candidate") {
      const response = await fetch("/sample_resume.docx");
      const blob = await response.blob();
      const file = new File([blob], "sample_resume.docx", { type: blob.type });
      const enrichedFile = {
        file,
        name: file.name,
        size: `${(file.size / 1024).toFixed(1)} KB`,
        type: file.type,
        progress: 0,
        buffer: 0,
        visible: false,
        delete: true,
        message: "",
      };
      setCandidateFiles([enrichedFile]);
      setQuickMatchValue(2);
      setEnableSample(false);
    }

    // setList({
    //   progress: 0,
    //   buffer: 0,
    // });
    // setIconVisible(true);
    // if (condition === "enrich_job") {
    //   setIsLoading(true);
    //   let progress = 0;

    //   const updateProgress = () => {
    //     setList((f) => {
    //       progress = f.progress + 10;
    //       const isComplete = progress >= 100;

    //       if (isComplete) {
    //         setTimeout(() => {
    //           navigate(
    //             `/onboarding?id=${localData?.onboarding_config?.onboarding_job}`
    //           );
    //           setFilteredQuickLink((prev) =>
    //             prev.map((item, index) => {
    //               if (index === 0) {
    //                 return {
    //                   ...item,
    //                   selected: true,
    //                 };
    //               }
    //               return item;
    //             })
    //           );
    //           setEnrichJobValue(2);
    //           setUploadJobData({
    //             id: localData?.onboarding_config?.onboarding_job,
    //           });
    //           setSnackbarState({
    //             open: true,
    //             message: "Update Successfully",
    //             severity: "success",
    //           });
    //           setIsLoading(false);
    //         }, 500);

    //         return { ...f, progress: 100, buffer: 100 };
    //       }

    //       setTimeout(updateProgress, 300);

    //       return {
    //         ...f,
    //         progress,
    //         buffer: progress,
    //         visible: false,
    //         delete: false,
    //       };
    //     });
    //   };
    //   setChatBotData((prev) => ({
    //     ...prev,
    //     selectedValue: "Job",
    //   }));

    //   updateProgress();
    // } else if (condition === "quick_match") {
    //   setIsLoading(true);
    //   let progress = 0;

    //   const updateProgress = () => {
    //     setList((f) => {
    //       progress = f.progress + 10;
    //       const isComplete = progress >= 100;

    //       if (isComplete) {
    //         setTimeout(() => {
    //           navigate(
    //             `/onboarding?id=${localData?.onboarding_config?.onboarding_job}&title=Software Engineer`
    //           );
    //           setFilteredQuickLink((prev) =>
    //             prev.map((item, index) => {
    //               if (index === 2) {
    //                 return {
    //                   ...item,
    //                   selected: true,
    //                 };
    //               }
    //               return item;
    //             })
    //           );
    //           setQuickMatchValue(3);
    //           setUploadJobData({
    //             id: localData?.onboarding_config?.onboarding_match,
    //           });
    //           setSnackbarState({
    //             open: true,
    //             message: "Update Successfully",
    //             severity: "success",
    //           });
    //           setIsLoading(false);
    //         }, 500);

    //         return { ...f, progress: 100, buffer: 100 };
    //       }

    //       setTimeout(updateProgress, 300);

    //       return {
    //         ...f,
    //         progress,
    //         buffer: progress,
    //         visible: false,
    //         delete: false,
    //       };
    //     });
    //   };

    //   updateProgress();
    // } else if (condition === "enrich_candidate") {
    //   setIsLoading(true);
    //   let progress = 0;
    //   setList({
    //     progress: 10,
    //     buffer: 10,
    //   });
    //   try {
    //     const data = await dispatch(
    //       CandidateViewCall(localData?.onboarding_config?.onboarding_resume)
    //     );

    //     setUploadJobData(data);
    //     const updateProgress = async () => {
    //       progress += 10;

    //       setList((f) => ({
    //         ...f,
    //         progress,
    //         buffer: progress,
    //         visible: false,
    //         delete: false,
    //       }));

    //       if (progress >= 100) {
    //         setTimeout(() => {
    //           navigate(
    //             `/onboarding?id=${localData?.onboarding_config?.onboarding_resume}`
    //           );

    //           setFilteredQuickLink((prev) =>
    //             prev.map((item, index) => {
    //               if (index === 1) {
    //                 return { ...item, selected: true };
    //               }
    //               return item;
    //             })
    //           );

    //           setEnrichCandidateValue(2);

    //           setSnackbarState({
    //             open: true,
    //             message: "Update Successfully",
    //             severity: "success",
    //           });

    //           setIsLoading(false);
    //         }, 500);

    //         return;
    //       }
    //       setTimeout(updateProgress, 300);
    //     };
    //     setChatBotData((prev) => ({
    //       ...prev,
    //       selectedValue: "Candidate",
    //     }));

    //     updateProgress();
    //   } catch (error) {
    //     setSnackbarState({
    //       open: true,
    //       message: error.message,
    //       severity: "error",
    //     });
    //     setList((f) => ({
    //       ...f,
    //       visible: true,
    //       delete: true,
    //       message: error.message,
    //     }));
    //     setIsLoading(false);
    //   }
    // }
  };

  const commonFileValidationCheck = (
    commonFiles,
    allowedTypes,
    setCommonFiles,
    existingFiles
  ) => {
    const validFiles = [];
    const invalidFiles = [];

    commonFiles.forEach((file) => {
      if (allowedTypes.includes(file.type)) {
        validFiles.push({
          file,
          name: file.name,
          size: `${(file.size / 1024).toFixed(1)} KB`,
          type: file.type,
          progress: 0,
          buffer: 0,
          visible: false,
          delete: true,
          message: "",
        });
      } else {
        invalidFiles.push(file.name);
      }
    });

    const mergedFiles = [
      ...existingFiles,
      ...validFiles.filter(
        (newFile) =>
          !existingFiles.some(
            (existingFile) => existingFile.name === newFile.name
          )
      ),
    ];
    setCommonFiles(mergedFiles);

    if (invalidFiles.length > 0) {
      setSnackbarState({
        open: true,
        message: `Unsupported file types: ${invalidFiles.join(", ")}`,
        severity: "error",
      });
    }
  };

  const handleFileUpload = (event) => {
    const selectedFiles = Array.from(event.target.files);
    commonFileValidationCheck(selectedFiles, allowedTypes, setFiles, files);
  };

  // Handle file deletion
  const handleDeleteFile = (index) => {
    setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    setIsDragging(false);

    const selectedFiles = Array.from(event.dataTransfer.files);
    commonFileValidationCheck(selectedFiles, allowedTypes, setFiles, files);
  };

  const handleCloseValidation = () => {
    setSnackbarState((prev) => ({
      ...prev,
      open: false,
    }));
  };

  const handlJDUploadClick = async () => {
    if (files.length == 0) {
      setSnackbarState((prev) => ({
        ...prev,
        open: true,
        message: "Upload the Files",
        severity: "error",
      }));
    } else {
      uploadFile("NextUpload");
    }
  };

  const handlEnrichJobUploadClick = () => {
    if (files.length == 0) {
      setSnackbarState((prev) => ({
        ...prev,
        open: true,
        message: "Upload the Files",
        severity: "error",
      }));
    } else {
      uploadFile("Enrich");
    }
  };

  const handlEnrichCandidateUploadClick = () => {
    if (files.length == 0) {
      setSnackbarState((prev) => ({
        ...prev,
        open: true,
        message: "Upload the Files",
        severity: "error",
      }));
    } else {
      uploadFile("Candidate");
    }
  };

  const uploadFile = async (getName) => {
    setIsLoading(true);
    setIconVisible(true);
    if (getName === "NextUpload" || getName === "Enrich") {
      setFiles((prevFiles) =>
        prevFiles.map((f) => ({
          ...f,
          visible: false,
          delete: false,
          message: "",
        }))
      );
    } else {
      setCandidateFiles((prevFiles) =>
        prevFiles.map((f) => ({
          ...f,
          visible: false,
          delete: false,
          message: "",
        }))
      );
    }
    const formData = new FormData();
    if (
      getName === "NextUpload" ||
      getName === "Enrich" ||
      getName === "Candidate"
    ) {
      files.forEach((fileObj, index) => {
        formData.append("files", fileObj.file);
      });
    } else {
      candidateFiles.forEach((fileObj, index) => {
        formData.append("resume_file", fileObj.file);
      });
      formData.append("id", uploadJobData?.id);
    }
    try {
      let response;
      if (getName === "Enrich") {
        response = await UploadJob(formData, "NextUpload", "Draft");
      } else if (getName === "Candidate") {
        response = await ResumeIntelligenceUpload(formData);
      } else {
        response = await UploadJob(formData, getName, "Active");
      }
      const reader = response.body.getReader();
      const decoder = new TextDecoder("utf-8");
      let buffer = "";

      while (true) {
        const { value, done } = await reader.read();
        if (done) break;
        const chunk = decoder.decode(value, { stream: true });
        buffer += chunk;
        let boundaryIndex;
        while ((boundaryIndex = buffer.indexOf("}\n")) !== -1) {
          const jsonString = buffer.slice(0, boundaryIndex + 1);
          buffer = buffer.slice(boundaryIndex + 1);
          const jsonResponse = JSON.parse(jsonString);
          try {
            await processJsonResponse(jsonResponse, getName, setCandidateFiles);
          } catch (e) {
            if (
              getName === "NextUpload" ||
              getName === "Enrich" ||
              getName === "Candidate"
            ) {
              setFiles((prevFiles) =>
                prevFiles.map((f) => ({
                  ...f,
                  visible: true,
                  delete: true,
                  message: jsonResponse.message,
                }))
              );
            } else {
              setSnackbarState({
                open: true,
                message: "Error parsing JSON",
                severity: "error",
              });
              setCandidateFiles((prevFiles) =>
                prevFiles.map((f) =>
                  f.name === jsonResponse.data.current_resume
                    ? {
                        ...f,
                        visible: true,
                        delete: true,
                      }
                    : { ...f, delete: true }
                )
              );
            }
          }
        }
      }

      if (buffer) {
        const jsonResponse = JSON.parse(buffer);
        try {
          await processJsonResponse(jsonResponse, getName, setCandidateFiles);
        } catch (e) {
          if (
            getName === "NextUpload" ||
            getName === "Enrich" ||
            getName === "Candidate"
          ) {
            setFiles((prevFiles) =>
              prevFiles.map((f) => ({
                ...f,
                visible: true,
                delete: true,
                message: jsonResponse.message,
              }))
            );
          } else {
            setSnackbarState({
              open: true,
              message: "Error parsing final JSON chunk",
              severity: "error",
            });
            setCandidateFiles((prevFiles) =>
              prevFiles.map((f) =>
                f.name === jsonResponse.data.current_resume
                  ? {
                      ...f,
                      visible: true,
                      delete: true,
                    }
                  : { ...f, delete: true }
              )
            );
          }
        }
      }
      setIsLoading(false);
    } catch (error) {
      if (
        getName === "NextUpload" ||
        getName === "Enrich" ||
        getName === "Candidate"
      ) {
        setFiles((prevFiles) =>
          prevFiles.map((f) => ({
            ...f,
            visible: true,
            delete: true,
            message: "Error during the request",
          }))
        );
      } else {
        setSnackbarState({
          open: true,
          message: "Error during the request",
          severity: "error",
        });
        setCandidateFiles((prevFiles) =>
          prevFiles.map((f) => ({
            ...f,
            visible: true,
            delete: true,
            message: "Error during the request",
          }))
        );
      }
      setIsLoading(false);
    }
  };

  const processJsonResponse = (jsonResponse, getName, setCandidateFiles) => {
    const { success, data, message } = jsonResponse;
    setUploadJobData(
      getName === "Candidate"
        ? data?.need_review?.[0] || data?.new_resumes?.[0]
        : data
    );
    if (success && data?.percent !== undefined) {
      if (
        getName === "NextUpload" ||
        getName === "Enrich" ||
        getName === "Candidate"
      ) {
        setFiles((prevFiles) =>
          prevFiles.map((f) => ({
            ...f,
            progress: data.percent,
            buffer: data.buffer || data.percent,
            visible: false,
            delete: false,
            progress_message: data.progress_message,
          }))
        );
      } else {
        setCandidateFiles((prevFiles) =>
          prevFiles.map((f) =>
            f.name === data.current_resume
              ? {
                  ...f,
                  progress: data.percent,
                  buffer: data.buffer || data.percent,
                  visible: false,
                  delete: false,
                  progress_message: data.progress_message,
                }
              : f
          )
        );
      }
    } else if (data?.id && getName === "NextUpload") {
      setSnackbarState({
        open: true,
        message: message,
        severity: "success",
      });
      if (enableSample) {
        setFiles([]);
        handleClickSample("quick_match_candidate");
      } else {
        setFiles([]);
        setQuickMatchValue(2);
      }
    } else if (data?.id && getName === "Enrich") {
      setSnackbarState({
        open: true,
        message: message,
        severity: "success",
      });
      setFiles([]);
      navigate(`/onboarding?id=${data?.id}`);
      setFilteredQuickLink((prev) =>
        prev.map((item, index) => {
          if (index === 0) {
            return {
              ...item,
              selected: true,
            };
          }
          return item;
        })
      );
      setEnrichJobValue(2);
      setChatBotData((prev) => ({
        ...prev,
        selectedValue: "Job",
      }));
    } else if (
      (data?.need_review?.length !== 0 || data?.new_resumes?.length !== 0) &&
      getName === "Candidate"
    ) {
      setSnackbarState({
        open: true,
        message: message,
        severity: "success",
      });
      setFiles([]);
      navigate(
        `/onboarding?id=${
          data?.need_review?.[0]?.id || data?.new_resumes?.[0]?.id
        }`
      );
      setFilteredQuickLink((prev) =>
        prev.map((item, index) => {
          if (index === 1) {
            return {
              ...item,
              selected: true,
            };
          }
          return item;
        })
      );
      setChatBotData((prev) => ({
        ...prev,
        selectedValue: "Candidate",
      }));
      setEnrichCandidateValue(2);
    } else if (
      data?.length !== 0 &&
      data?.[0]?.jd_info &&
      getName === "Upload-Candidate"
    ) {
      setSnackbarState({
        open: true,
        message: message,
        severity: "success",
      });
      setFiles([]);
      navigate(
        `/onboarding?id=${data?.[0]?.jd_info}&title=${data?.[0]?.resume_info?.inferred_title}`
      );
      setFilteredQuickLink((prev) =>
        prev.map((item, index) => {
          if (index === 2) {
            return {
              ...item,
              selected: true,
            };
          }
          return item;
        })
      );
      setQuickMatchValue(3);
    } else if (!success) {
      if (
        getName === "NextUpload" ||
        getName === "Enrich" ||
        getName === "Candidate"
      ) {
        setFiles((prevFiles) =>
          prevFiles.map((f) => ({
            ...f,
            visible: true,
            delete: true,
            message: message,
          }))
        );
      } else {
        setCandidateFiles((prevFiles) =>
          prevFiles.map((f) =>
            f.name === data.current_resume || data.length == 0
              ? {
                  ...f,
                  visible: true,
                  delete: true,
                  message: message,
                }
              : { ...f, delete: true }
          )
        );
      }
    }
  };

  const handleCandidateDragOver = (event) => {
    event.preventDefault();
    setIsCandidateDragging(true);
  };

  const handleCandidateDragLeave = () => {
    setIsCandidateDragging(false);
  };

  const handleCandidateDrop = (event) => {
    event.preventDefault();
    setIsCandidateDragging(false);
    const droppedFiles = Array.from(event.dataTransfer.files);
    commonFileValidationCheck(
      droppedFiles,
      allowedTypes,
      setCandidateFiles,
      candidateFiles
    );
  };

  const handleCandidateDeleteFile = (index) => {
    setCandidateFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  const handleCandidateFileUpload = (event) => {
    const selectedFiles = Array.from(event.target.files);
    commonFileValidationCheck(
      selectedFiles,
      allowedTypes,
      setCandidateFiles,
      candidateFiles
    );
  };

  const handlResumeUploadClick = async () => {
    if (candidateFiles.length == 0) {
      setSnackbarState({
        open: true,
        message: "Upload the Files",
        severity: "error",
      });
    } else {
      uploadFile("Upload-Candidate");
    }
  };

  const handleGetStarted = async () => {
    try {
      setIsLoading(true);
      await GetStartedCall(localData?.organization_id);
      const credential = JSON.parse(localStorage.getItem("credential") || "{}");
      credential.is_onboarding_completed = true;
      localStorage.setItem("credential", JSON.stringify(credential));
      navigate("/home");
      setIsLoading(false);
    } catch (error) {
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
      setIsLoading(false);
    }
  };

  const handleChatBotJobCall = async () => {
    setChatBotData((prev) => ({
      ...prev,
      pageLoader: true,
    }));
    try {
      const data = await ChatBotGetCall(jobId);
      const messages = [];
      data?.data?.history?.forEach((entry) => {
        if (entry.user) {
          const userMessage = {
            sender: "user",
            text: entry.user,
          };
          messages.push(userMessage);
        }
        if (entry.assistant) {
          const botMessage = {
            sender: "bot",
            text: entry.assistant,
          };
          messages.push(botMessage);
        }
      });

      setChatBotData((prev) => ({
        ...prev,
        message: [...messages],
        bubble: data?.data?.bubble_questions,
        pageLoader: false,
      }));
      setIsBottomVisible(false);
    } catch (error) {
      setChatBotData((prev) => ({
        ...prev,
        pageLoader: false,
      }));
      setSnackbarState({
        open: true,
        severity: "error",
        message: error?.message,
      });
    }
  };

  const handleChatBotCandidateCall = async () => {
    setChatBotData((prev) => ({
      ...prev,
      pageLoader: true,
    }));
    try {
      const data = await CandidateChatBotGetCall(jobId);
      const messages = [];
      data?.data.forEach((entry) => {
        if (entry.user) {
          const userMessage = {
            sender: "user",
            text: entry.user,
          };
          messages.push(userMessage);
        }
        if (entry.assistant) {
          const botMessage = {
            sender: "bot",
            text: entry.assistant,
          };
          messages.push(botMessage);
        }
      });

      setChatBotData((prev) => ({
        ...prev,
        message: [...messages],
        pageLoader: false,
      }));
      setIsBottomVisible(false);
    } catch (error) {
      setChatBotData((prev) => ({
        ...prev,
        pageLoader: false,
      }));
      setSnackbarState({
        open: true,
        severity: "error",
        message: error?.message,
      });
    }
  };

  console.log(chatBotData, "chatBotDatachatBotData");
  const handleSendMessage = async () => {
    if (!chatBotData.value.trim()) return;
    let payload;
    if (chatBotData.selectedValue === "Job") {
      payload = {
        query: chatBotData.value,
        filter_criteria: {
          type: "match_data",
          job_data_id: jobId,
        },
      };
    } else if (chatBotData.selectedValue === "Candidate") {
      payload = {
        query: chatBotData.value,
        filter_criteria: {
          type: "resume_data",
          resume_data_id: jobId,
        },
      };
    } else {
      payload = {
        query: chatBotData.value,
        filter_criteria: {
          type: "user_manuals",
          user_id: localStorageData?.user_id,
        },
      };
    }

    setChatBotData((prev) => ({
      ...prev,
      message: [...prev.message, { sender: "user", text: chatBotData.value }],

      loader: true,
      value: "",
    }));

    try {
      let data;
      if (chatBotData.selectedValue === "Job") {
        data = await dispatch(ChatBotCall(payload));
      }
      if (chatBotData.selectedValue === "Candidate") {
        data = await dispatch(CandidateChatBot(payload));
      } else {
        data = await SupportCall(payload);
      }
      const botResponse = {
        sender: "bot",
        text: data?.data?.response,
      };
      setChatBotData((prev) => ({
        ...prev,
        message: [...prev.message, botResponse],

        loader: false,
      }));
    } catch (error) {
      const botResponse = {
        sender: "error",
        text: error?.data?.message,
      };
      setChatBotData((prev) => ({
        ...prev,
        message: [...prev.message, botResponse],

        loader: false,
        value: "",
      }));
      setSnackbarState({
        open: true,
        severity: "error",
        message: error?.message,
      });
    }
  };

  const handleChatBotChange = (event) => {
    setChatBotData((prev) => ({
      ...prev,
      value: event.target.value,
    }));
    if (event.key === "Enter") {
      handleSendMessage();
    }
  };

  const handleUpArrow = (condition) => {
    setChatBotData((prev) => ({
      ...prev,
      arrow: condition === "up" ? false : true,
    }));
  };

  const handleButtonSupport = (name) => {
    setChatBotData((prev) => ({
      ...prev,
      selectedValue: name === "Report Bug" ? prev.selectedValue : name,
    }));
    if (name === "Support") {
      handleSupportCall();
    } else if (name === "Job") {
      handleChatBotJobCall();
    } else if (name === "Candidate") {
      handleChatBotCandidateCall();
    }
  };

  const handleSupportCall = async () => {
    setChatBotData((prev) => ({
      ...prev,
      pageLoader: true,
    }));
    try {
      const data = await SupportGetCall(localStorageData?.user_id);
      const messages = [];
      data?.history?.forEach((entry) => {
        if (entry.user) {
          const userMessage = {
            sender: "user",
            text: entry.user,
          };
          messages.push(userMessage);
        }
        if (entry.assistant) {
          const botMessage = {
            sender: "bot",
            text: entry.assistant,
          };
          messages.push(botMessage);
        }
      });

      setChatBotData((prev) => ({
        ...prev,
        message: [...messages],
        bubble: data?.data?.bubble_questions,
        pageLoader: false,
      }));
      setIsBottomVisible(false);
    } catch (error) {
      setChatBotData((prev) => ({
        ...prev,
        pageLoader: false,
      }));
      setSnackbarState({
        open: true,
        severity: "error",
        message: error?.message,
      });
    }
  };

  const handleChatBotClick = (value) => {
    setIconVisible(value);
    if (!value) {
      if (chatBotData.selectedValue === "Support") {
        handleSupportCall();
      } else if (chatBotData.selectedValue === "Candidate") {
        handleChatBotCandidateCall();
      } else {
        handleChatBotJobCall();
      }
    }
  };

  return (
    <Box spacing={2} minHeight={"100vh"} display={"flex"}>
      <TabContext value={value}>
        <CommonGrid2
          item
          width={"300px"}
          background="#1A1425"
          padding={"2rem"}
          position={"fixed"}
          height={"100vh"}
        >
          {platformWhiteLogo()}
          <StepperStyle activeStep={activeStep} orientation="vertical">
            {steps.map((step, index) => (
              <Step key={step.label}>
                <StepLabel StepIconComponent={QontoStepIcon}>
                  <CommonGrid2
                    display={"flex"}
                    flexDirection={"column"}
                    gap={"5px"}
                    marginLeft={"0.8rem"}
                  >
                    <Typography variant="span" color="#8396A8">
                      {step.label}
                    </Typography>
                    <Typography variant="body5" color="#fff" fontWeight={600}>
                      {step.description}
                    </Typography>
                    {index === 1 && (
                      <>
                        <StepperTabList
                          aria-disabled
                          aria-label="lab API tabs example"
                        >
                          <CustomTab
                            value={1}
                            background={
                              filteredQuickLink[0].selected
                                ? "#17B26A"
                                : "#7F56D9"
                            }
                          />
                          <CustomTab
                            value={2}
                            background={
                              filteredQuickLink[1].selected
                                ? "#17B26A"
                                : "#7F56D9"
                            }
                          />
                          <CustomTab
                            value={3}
                            background={
                              filteredQuickLink[2].selected
                                ? "#17B26A"
                                : "#7F56D9"
                            }
                          />
                        </StepperTabList>
                      </>
                    )}
                    <Typography variant="span" color="#D7C4F3">
                      {step.status}
                    </Typography>
                  </CommonGrid2>
                </StepLabel>
              </Step>
            ))}
          </StepperStyle>
          {(jobId || viewId) && (
            <CommonButton
              value={"Back to Demo"}
              marginTop={"2rem"}
              width={"100%"}
              padding={"8px"}
              onClick={() => handleDemoBack("back_to_demo", "")}
            />
          )}
        </CommonGrid2>
        <CommonGrid2
          item
          // width={"calc(100% - 300px)"}
          width="100%"
          marginLeft={"300px"}
          padding={jobId || viewId ? "0px" : "2rem"}
        >
          {activeStep === 0 && (
            <Introduction
              handleSkip={handleSkip}
              handleNext={() => handleNext(1)}
            />
          )}
          {activeStep === 1 && (
            <>
              {value === "" && (
                <StartDemo
                  handleBack={handleBack}
                  handleNext={handleNext}
                  filteredQuickLink={filteredQuickLink}
                  handleCheckChange={handleCheckChange}
                  handleDemoCardChange={handleDemoCardChange}
                  handleSkip={handleSkip}
                />
              )}
              <TabPanelView value={0} padding="0px" height="100%">
                <EnrichJob
                  handleDemoBack={handleDemoBack}
                  enrichJobValue={enrichJobValue}
                  handleClickDemo={handleClickDemo}
                  handleDragOver={handleDragOver}
                  handleDragLeave={handleDragLeave}
                  handleDrop={handleDrop}
                  handleFileUpload={handleFileUpload}
                  isDragging={isDragging}
                  files={files}
                  handleDeleteFile={handleDeleteFile}
                  isLoading={isLoading}
                  handlEnrichJobUploadClick={handlEnrichJobUploadClick}
                  uploadJobData={uploadJobData}
                  handleClickSample={handleClickSample}
                  list={list}
                  iconVisible={iconVisible}
                  enrichButtonSupport={enrichButtonSupport}
                  chatBotData={chatBotData}
                  isBottomVisible={isBottomVisible}
                  setIsBottomVisible={setIsBottomVisible}
                  handleChatBotChange={handleChatBotChange}
                  handleUpArrow={handleUpArrow}
                  handleSendMessage={handleSendMessage}
                  handleButtonSupport={handleButtonSupport}
                  handleChatBotClick={handleChatBotClick}
                />
              </TabPanelView>
              <TabPanelView value={1} padding="0px" height="100%">
                <EnrichCandidate
                  handleDemoBack={handleDemoBack}
                  enrichCandidateValue={enrichCandidateValue}
                  handleClickDemo={handleClickDemo}
                  handleDragOver={handleDragOver}
                  handleDragLeave={handleDragLeave}
                  handleDrop={handleDrop}
                  handleFileUpload={handleFileUpload}
                  isDragging={isDragging}
                  files={files}
                  handleDeleteFile={handleDeleteFile}
                  isLoading={isLoading}
                  handlEnrichCandidateUploadClick={
                    handlEnrichCandidateUploadClick
                  }
                  uploadJobData={uploadJobData}
                  list={list}
                  handleClickSample={handleClickSample}
                  iconVisible={iconVisible}
                  candidateButtonSupport={candidateButtonSupport}
                  chatBotData={chatBotData}
                  isBottomVisible={isBottomVisible}
                  setIsBottomVisible={setIsBottomVisible}
                  handleChatBotChange={handleChatBotChange}
                  handleUpArrow={handleUpArrow}
                  handleSendMessage={handleSendMessage}
                  handleButtonSupport={handleButtonSupport}
                  handleChatBotClick={handleChatBotClick}
                  bounds={bounds}
                />
              </TabPanelView>
              <TabPanelView value={2} padding="0px" height="100%">
                <QuickMatch
                  handleDemoBack={handleDemoBack}
                  quickMatchValue={quickMatchValue}
                  handleClickDemo={handleClickDemo}
                  handleFileUpload={handleFileUpload}
                  handleDeleteFile={handleDeleteFile}
                  files={files}
                  isDragging={isDragging}
                  handleDragOver={handleDragOver}
                  handleDragLeave={handleDragLeave}
                  handleDrop={handleDrop}
                  handlJDUploadClick={handlJDUploadClick}
                  isLoading={isLoading}
                  handleCandidateDragOver={handleCandidateDragOver}
                  handleCandidateDragLeave={handleCandidateDragLeave}
                  handleCandidateDrop={handleCandidateDrop}
                  handleCandidateFileUpload={handleCandidateFileUpload}
                  isCandidateDragging={isCandidateDragging}
                  candidateFiles={candidateFiles}
                  handleCandidateDeleteFile={handleCandidateDeleteFile}
                  disabled={isLoading}
                  handlResumeUploadClick={handlResumeUploadClick}
                  list={list}
                  handleClickSample={handleClickSample}
                />
              </TabPanelView>
            </>
          )}
          {activeStep === 2 && (
            <GetStarted
              handleGetStarted={handleGetStarted}
              isLoading={isLoading}
            />
          )}

          {/* <Box mt={2}>
          <Button disabled={activeStep === 0} onClick={handleBack}>
            Back
          </Button>
          <Button
            variant="contained"
            onClick={handleNext}
            disabled={activeStep === steps.length - 1}
            sx={{ ml: 1 }}
          >
            Next
          </Button>
        </Box> */}
        </CommonGrid2>
      </TabContext>
      <SnackBar
        snackbarState={snackbarState}
        handleCloseValidation={handleCloseValidation}
      />
    </Box>
  );
}
